export default {
  titleOne: '我们是谁？',
  contentOne: `我们是一家中国与加拿大合资的专业控制阀门制造商，深耕工业控制领域六十年的流体方案专家`,
  historyForSummarize: {
    bgImgSrc: require('@/assets/images/home/history_for_summarize_bg.jpg'),
    children: [
      {
        title: '满意客户',
        subTitle: '860+',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon01.png'),
      },
      {
        title: '完成项目',
        subTitle: '960',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon02.png'),
      },
      {
        title: '优良反馈',
        subTitle: '99%',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon03.png'),
      },
      {
        title: '整机数量',
        subTitle: '80000+',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon04.png'),
      }
    ]
  },
  /* aboutList: [
    {
      imgsrc: require("@/assets/images1/index/img1.png"),
      name: "我们设计阀门",
      introductior:
        "无锡凯尔克(KELK)设计部门致力于设计高品质，高可靠性，高安全性的阀门产品。我们采用先进的软件对产品进行正向设计和逆向工程",
    },
    {
      imgsrc: require("@/assets/images1/index/img2.png"),
      name: "我们制造阀门",
      introductior:
        "无锡凯尔克(KELK)一直致力于以关键零部件进口（如填料和弹簧）的方式制造出质量接近于原装，价格接近于国产的高性价比的产品",
    },
    {
      imgsrc: require("@/assets/images1/index/img3.png"),
      name: "我们维修阀门",
      introductior:
        "无锡凯尔克(KELK) 设有一支专业的阀门售后，维护和检修的队伍，对外承接各类阀门的维保和检修项目，大大提高了产品的附加值",
    },
  ], */
  aboutList: [
    {
      imgsrc: require("@/assets/images1/index/img1.png"),
      name: "三位一体设计体系",
      introductior:
        `
        无锡凯尔克以"可靠性金字塔"模型驱动研发，融合CFD流体仿真/三维激光测绘技术，通过API 6D/ASME认证标准打造核电级安全阀门
        `,
    },
    {
      imgsrc: require("@/assets/images1/index/img2.png"),
      name: "全球供应链协同智造",
      introductior:
        `
        采用德国高弹性密封填料、日本精密弹簧等进口核心组件，结合模块化专利工艺，实现性能比肩进口、成本优化30%的硬核产品矩阵
        `,
    },
    {
      imgsrc: require("@/assets/images1/index/img3.png"),
      name: "全生命周期服务生态",
      introductior:
        `
        配备CNAS认证实验室及百人专家团队，提供智能诊断/核心部件再生服务，年进口设备再生修复率超95%，重塑工业装备价值链
        `,
    },
  ],
  titleTwo: '我们的行业',
  // titleTwo: 'KELK 多领域流体专家',
  // contentTwo: '无锡凯尔克为石油天然气、石化化工、精细化工、冶金有色、工业气体、能源环保、电力拖动等工业控制领域和仪器仪表行业提供和维护设备超过60年，特别是控制阀和具有高技术含量的控制设备以及客户支持服务。这些领域对于阀门都有非常高的要求',
  contentTwo: `
  <div style="text-align:justify;text-align-last: center;">
    深耕石油炼化、清洁能源、冶金智造等严苛工况领域六十载，无锡凯尔克以超低温深冷阀、电站主蒸汽调节阀等尖端流体控制产品，定义工业安全与效能标杆。从LNG超临界储运到氢能超高压控制，从智能冶金高炉到环保脱硫装置，我们以多级降压迷宫阀芯、金属波纹管动态密封等18项专利技术，为全球工业巨头定制研发各类标准的高端控制设备及全生命周期管理服务，用中国精度重塑工业控流标准
  </div>
  `,
  titleThree: '我们的能力',
  contentThree: '',
  abilityList: [
    {
      imgsrc: require("@/assets/images1/icon1.png"),
      name: "工程设计能力",
      english: "Engineering Design",
      id: 1,
    },
    {
      imgsrc: require("@/assets/images1/icon2.png"),
      name: "加工焊接能力",
      english: "Machining and Welding",
      id: 2,
    },
    {
      imgsrc: require("@/assets/images1/icon3.png"),
      name: "生产铸造能力",
      english: "Production Casting",
      id: 3,
    },
    {
      imgsrc: require("@/assets/images1/icon4.png"),
      name: "供应管理能力",
      english: "Supply Management",
      id: 4,
    },
  ],
  titleFour: '我们的动态',
  contentFour: '',
  titleFive: '我们的故事',
  contentFive: '',
  titleSix: '我们的客户',
  contentSix: '',
  // 悬浮公告弹框
  bannerPopup: {
    title: '公告',
    linkText: '点击前往',
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/homePage.js